export const SEND_RECOMMEND_TO_A_FRIEND = 'SEND_RECOMMEND_TO_A_FRIEND';
